import { search } from '../searchService';
import { post, put, del, getById } from '../apiService';
import type { ContentCertification } from '../../types/content/certification';
import type { SearchParams } from '../../types/search';

export async function searchCertifications(
  filter: object = {},
  params: SearchParams = {},
): Promise<ContentCertification[]> {
  return search<ContentCertification>('/certification/search', filter, params);
}

export async function getCertificationById(id: string): Promise<ContentCertification> {
  return getById<ContentCertification>('/certification', id);
}

export async function createCertification(data: Partial<ContentCertification>): Promise<ContentCertification> {
  return post<ContentCertification>('/certification', data);
}

export async function updateCertification(id: string, data: ContentCertification): Promise<ContentCertification> {
  return put<ContentCertification>(`/certification/${id}`, data);
}

export async function deleteCertification(id: string): Promise<void> {
  return del<void>(`/certification/${id}`);
}
